/*eslint-disable */

import 'cropperjs/dist/cropper.css';

import {
  mapGetters,
  mapState
} from 'vuex';

import VueCropper from 'vue-cropperjs';
import toast from '@/services/toast';

var $ = window.jQuery = jQuery = require('jquery');
export default {
  name: 'userImageBox',
  components: {
    VueCropper
  },
  props: [],
  data() {
    return {
      userImage: '',
      overlay: false,
      fileName: '',
      showModal: false,
      cropImg: '',
      imgSrc: '',
      data: null
    }
  },
  computed: {
    ...mapGetters([
      'getProfileInfo'
    ]),
    ...mapState([
      'profileInfo'
    ]),

    getUserImage() {
      cache: false,
      this.userImage =  this.$store.state.profileStore.profileInfo.data;
      return this.userImage
    },
  },
  mounted() {
    this.getUserImage;
  },
  methods: {
    cancelCrop() {
      this.$refs.cropper.reset();
      this.imgSrc = '';
      this.fileName = '';
    },
    setImage(e) {
      const file = e.target.files[0];
      this.fileName = file.name;
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      let cropperImg = this.cropImg;
      cropperImg = cropperImg.replace(/^data:image\/(png|jpg);base64,/, "")
      let data = {
        "avatar": cropperImg,
        "filename": this.fileName,
      }
      this.$store.dispatch('updateAvtar', data).then((res) => {
        if (res.data.status == '415') {
          toast.error('Media not supported');
        } else {
          this.imgSrc = '';
          this.$store.dispatch('getProfile').then((res) => {
            
            this.userImage = res.data.data.profile.avatar;
          })
        }
      })
    },
    getImgUrl(pic) {
      if (pic == '' || !pic || pic == 'undefined') {
        return require('./../../assets/images/user_default.png')
      } else {
        return pic
      }
    },
    onFileChange(e) {
      let value = e.target.files[0];
      this.fileName = value.name;
      var files = e.target.files || e.dataTransfer.files;
      let data = new FormData();
      data.append('avatar', value);
      data.append('filename', this.fileName);
      if (!files.length) {
        return;
      } else {
        this.createImage(files[0]);
        this.$store.dispatch('updateAvtar', data).then((res) => {
          if (res.data.status == '415') {
            toast.error('Media not supported');
          } else {
            this.$store.dispatch('getProfile').then((res) => {
              this.userImage = res.data.data.profile.avatar;
            })
          }
        })
      }
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        this.userImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage() {
      this.$store.dispatch('removeAvtar').then((res) => {
        if (res.status == '200') {
          this.$store.dispatch('getProfile').then((res) => {
            this.userImage = res.data.data.profile.avatar;
            
            this.fileName = ''
          })
          return
        }
      }).catch((err) => {
      })
    },
    showOverlay() {
      this.showModal = true;
      $('body').addClass('showoverlay');
    },
    hideOverlay() {
      this.showModal = false;
      this.imgSrc = '';
      $('body').removeClass('showoverlay');
    }
  },
  watch: {
    getUserImage() {
      return this.$store.state.profileStore.profileInfo.data;
    }
  }
}